import { Box, useTheme, makeStyles } from '@material-ui/core';
import React from 'react';

import loadable from '@loadable/component';
import { Link } from 'gatsby-theme-material-ui';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

const HidingFooter = loadable(() =>
  import('../../components/hiding-footer/hiding-footer')
);

const useStyles = makeStyles(({ typography }) => ({
  heading1: {
    ...typography.h4,
  },
  heading2: {
    ...typography.subtitle1,
  },
}));

const HeroMobile = () => {
  const theme = useTheme();
  const classes = useStyles();
  const handleHeroGetStarted = () => {
    trackCustomEvent({
      category: "Get Started",
      action: "Click",
      label: "Get Started - Hero",
    })
  }

  const handleBottomGetStarted = () => {
    trackCustomEvent({
      category: "Get Started",
      action: "Click",
      label: "Get Started - Bottom",
    })
  }
  
  return (
    <>
      <div className="absolute w-full overflow-x-hidden">
        {/* <Logo style={{ width: 91, height: 25.82 }} className="mt-16 ml-16" /> */}
        <div className="pt-60 flex justify-center w-full">
          <div className="flex justify-between">
            <div
              style={{ color: theme.palette.primary.contrastText }}
              className="ml-16"
            >
              <h1 className={classes.heading1}>
                Get Your Affordable <br />
                Personal Trainer!
              </h1>
              <Box mt={4} mr={2}>
                <h2 className={classes.heading2}>
                  Connect with the perfect fitness coach over the messenger,
                  follow a custom-made workout tasks, and consistently get
                  feedback from your trainer. All in one for an exclusive price.
                </h2>
              </Box>
              <Link underline="none" to="/trainers/" onClick={handleHeroGetStarted}>
                <div
                  className="mt-40 font-sans text-20 font-medium text-white flex justify-center items-center bg-dark-shade focus:outline-none hover:bg-dark-shade rounded-lg"
                  style={{ width: 163, height: 50 }}
                >
                  Get Started
                </div>
              </Link>
            </div>
          </div>
        </div>
        <img
          className="mt-90 ml-auto -mr-70"
          src="mockup.svg"
          alt="iPhone mockup"
        />
      </div>
      <div
        className="w-full bg-no-repeat bg-cover"
        style={{ backgroundImage: `url('./top-bg.svg')`, height: '780px' }}
      />
    </>
  );
};

export default HeroMobile;
